import Control from "ol/control/Control"

export default class MapControl extends Control {
  constructor(opt_options = {}) {
    const {
      clickevt = () => {},
      label = '',
      fontSize = '12px',
      fontWeight = 'normal',
      width = '40px',
      height = '40px',
      top='auto',
      right='auto',
      left='auto',
      bottom='auto',
      target,
      cls
    } = opt_options;
    let lbl=label
    if(Array.isArray(lbl))lbl=`<div style="height:${fontSize}">${label[0]}</div>`+label[1]
    const button = document.createElement('button');
    button.innerHTML = lbl;
    button.style.fontSize = fontSize;
    button.style.fontWeight = fontWeight;
    button.style.width = width;
    button.style.height = height;

    const element = document.createElement('div');
    element.className = 'ol-unselectable ol-control';
    if(cls)element.className+=' '+cls
    element.style.position = 'absolute';
    element.style.top = top;
    element.style.right = right;
    element.style.left = left;
    element.style.bottom = bottom;
    element.appendChild(button);
    super({
      element: element,
      target: target,
    });
    button.addEventListener('click',clickevt, false)
  }
}
